import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(with-global-style)/accounting/bridge-course/DesktopPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(with-global-style)/accounting/bridge-course/MobilePage.tsx");
